/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolApartmentIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-apartment"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.75 22.95Q2.63 22.95 1.86 22.19Q1.1 21.43 1.1 20.3L1.1 8.5Q1.1 7.38 1.86 6.61Q2.63 5.85 3.75 5.85L5.9 5.85L5.9 3.7Q5.9 2.58 6.66 1.81Q7.42 1.05 8.55 1.05L15.5 1.05Q16.63 1.05 17.39 1.81Q18.15 2.58 18.15 3.7L18.15 10.7L20.3 10.7Q21.43 10.7 22.19 11.46Q22.95 12.22 22.95 13.35L22.95 20.3Q22.95 21.43 22.19 22.19Q21.43 22.95 20.3 22.95L13.3 22.95L13.3 18.15L10.7 18.15L10.7 22.95ZM3.75 20.3L5.9 20.3L5.9 18.15L3.75 18.15ZM3.75 15.5L5.9 15.5L5.9 13.35L3.75 13.35ZM3.75 10.65L5.9 10.65L5.9 8.5L3.75 8.5ZM8.55 15.5L10.7 15.5L10.7 13.35L8.55 13.35ZM8.55 10.65L10.7 10.65L10.7 8.5L8.55 8.5ZM8.55 5.85L10.7 5.85L10.7 3.7L8.55 3.7ZM13.35 15.5L15.5 15.5L15.5 13.35L13.35 13.35ZM13.35 10.65L15.5 10.65L15.5 8.5L13.35 8.5ZM13.35 5.85L15.5 5.85L15.5 3.7L13.35 3.7ZM18.15 20.3L20.3 20.3L20.3 18.15L18.15 18.15ZM18.15 15.5L20.3 15.5L20.3 13.35L18.15 13.35Z" fill={color} />
    </svg>
  );
}
